import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-about__cap" }
const _hoisted_2 = { style: {"margin-top":"20px","font-size":"small"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, "このボタンからサービスに戻らずに画面を閉じられた場合、変更いただいた内容は次回ログインされるまで" + _toDisplayString(_ctx.siteName) + "に反映されません", 1)
  ]))
}